
















































































































import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Prop, PropSync } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../../logic/helpers/DrawerWidthMixin'
import CustomEditor from '../../logic/Editor/CustomEditor'
import { EditorViewMode } from '../../logic/Editor/types'
import History from "../../logic/FlowHistory/History";
import { getAreaBackgroundState, setAreaState } from '../../logic/Helpers/AreaPluginBackgroundHelper'
import { FlowAccessor } from "../../types";
import FlowHintComponent from './components/FlowHintComponent.vue'

@Component({
  data() {
    return {
      isMobile,
      History
    }
  },
  components: {
    FlowHintComponent,
  }
})
export default class FlowNavbar extends DrawerWidthMixin {
  @Prop() editor!: CustomEditor

  @PropSync('showMinimap') minimapIsVisible!: boolean

  private token = getAreaBackgroundState()

  saveFlow(): void {
    this.editor.saveFlow()
  }

  toggleStatistics() {
    if (this.editor.isStatisticsViewSelected) {
      this.editor.viewMode = EditorViewMode.Editor
    } else {
      this.editor.viewMode = EditorViewMode.Statistics
    }
  }

  showMap(): void {
    this.minimapIsVisible = !this.minimapIsVisible
  }

  zoom(k: number): void {
    const { area } = this.editor.view
    const rect = area.el.getBoundingClientRect()
    const ox = (rect.left - window.innerWidth / 2) * k
    const oy = (rect.top - window.innerHeight / 2) * k

    area.zoom(area.transform.k + k, ox, oy, 'wheel')
  }

  goInBackRoute(): void {
    this.$router.back()
  }

  startTestingFlow(): void {
    this.editor.flowSettingsController.startTesting()
  }

  handleChangeArea() {
    if (getAreaBackgroundState() === 'visible') {
      setAreaState('hidden')
    } else {
      setAreaState('visible')
    }

    this.token = getAreaBackgroundState()
  }

  handleAccessorClick() {
    const { scheme } = this.editor.flowConfig.data
    if (!scheme.accessor) {
      scheme.initAccessorModel()

      if (this.editor.flowConfig.data.scheme.accessor instanceof FlowAccessor) {
        this.editor.flowConfig.data.scheme.accessor.accessorButtonClick()
      }
    } else {
      scheme.accessor.accessorButtonClick()
    }

  }

}
